import { createAsyncThunk } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import { RootState } from './rootReducer';
import { AppDispatch } from './store';

export type Action<T, P> = {
	type: T;
	payload?: P;
};

interface ActionProps<T, P> {
	type: T;
	payload?: P;
}

export const createAction = <T extends string, P>(type: T, payload?: P): ActionProps<T, P> => {
	return { type, payload };
};

export const useActions = <T extends ActionCreatorsMapObject>(actions: T) => {
	const dispatch = useAppDispatch();

	return bindActionCreators(actions, dispatch);
};

export const useAppDispatch = () => {
	return useDispatch<AppDispatch>();
};

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
	state: RootState;
	dispatch: AppDispatch;
}>();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
